export const ACCOUNT_KEY = '@inter-cdpro/account-data'

export const IS_DEVELOPMENT = process.env.REACT_APP_NODE_ENV === 'development'
export const IS_TEST = process.env.NODE_ENV === 'test'

export const TERMS_TITLE = 'Cheque Especial'
